// The API_URL variable contain the backend API URL (.NET Core).
export const API_URL = 'https://epcvoieapi.awesometechinc.com/epc-api/voie';
export const ORIGIN_PATH = '/api/origins/EncompassPartnerConnect/Retrieve/';
export const STATUS_PATH = '/api/status/EncompassPartnerConnect/Retrieve/';
export const PROVIDER_PATH = '/api/provider/EncompassPartnerConnect/Retrieve/';
export const PRODUCT_PATH = '/api/product/EncompassPartnerConnect/Retrieve/';
export const AUDITLOG_PATH = '/api/AuditLog/EncompassPartnerConnect/Retrieve/';


export const REQUEST_TYPE = 'VOIE SMARTOrder';
export const REQUEST_TYPE_ADMIN = 'Lenders One VOIE SMARTOrder Automated';